module.exports = __webpack_public_path__ + "img/Kromnix-logo-vertical_light_bg.a03a4ab9.png";